export enum AdvogadosStatusEnum {
    ATIVO = 'ATIVO',
    INATIVO = 'INATIVO'
}
